import { createFileRoute, useParams } from '@tanstack/react-router'
import { TagsManagementPage } from '../../../../components/tags/TagsManagementPage'

export const Route = createFileRoute('/$org/settings/tags/')({
    component: SettingsTagsIndexPage,
})

function SettingsTagsIndexPage() {
    const { org } = useParams({ from: '/$org/settings/tags/' })
    return <TagsManagementPage org={org} />
}
